import { useMutation } from "@tanstack/react-query";
import { ParsedPromptSectionData, promptEditorApi, PromptSectionRequest } from "src/services/experiences/promptEditor";

export const usePromptEditorSection = () => {
  return useMutation<
    ParsedPromptSectionData,
    Error,
    { request: PromptSectionRequest; workspaceId: string }
  >({
    mutationFn: ({ request, workspaceId }) =>
      promptEditorApi.generateSection(request, workspaceId),
  });
};